import React, { useState, useEffect } from 'react'
import Page from 'layouts/Page'
import BreadcrumbNav from 'enrollment-platform/components/Breadcrumbs'
import { Button, Stack } from '@sureco/design-system'
import { useRouterContext } from 'components/RouterContext'
import useSmokerRatesAnalyzeDiff from './hooks/useSmokerRatesAnalyzeDiff'
import useSmokerRatesImport from './hooks/useSmokerRatesImport'
import AnalyzeSummary from '../../components/AnalyzeSummary'
import { filterDiffStatusNotUnchanged } from '../../helpers/helper'
import { Modal } from 'antd'

export default function AnalyzeSmokerRates({ params }) {
  const importBatchId = params?.importBatchId || 'No importBatchId provided'
  const [isModalVisible, setIsModalVisible] = useState(false)
  const {
    mutate: diffMutate,
    data: diffData,
    isLoading: diffIsLoading,
  } = useSmokerRatesAnalyzeDiff({ importBatchId, batchType: 'smoker-rates' })
  const { mutate: importMutate, isLoading: importIsLoading } =
    useSmokerRatesImport({ importBatchId, batchType: 'smoker-rates' })
  const { router } = useRouterContext()

  useEffect(() => {
    diffMutate()
  }, [importBatchId])

  const handleImport = () => {
    setIsModalVisible(false)
    importMutate()
  }

  return (
    <Page
      title="Analyze"
      breadcrumb={
        <BreadcrumbNav
          items={[
            { title: 'Plan Management', path: '/plans' },
            { title: 'Home' },
          ]}
        />
      }
    >
      <Stack space={20}>
        <Button onClick={() => router.push('/plans')}>Back to Home</Button>
        <Button
          onClick={() => setIsModalVisible(true)}
          loading={importIsLoading}
        >
          Import Smoker Rates
        </Button>
        <Modal
          title="Confirm Import"
          visible={isModalVisible}
          onOk={handleImport}
          onCancel={() => setIsModalVisible(false)}
          okText="Yes, Import"
          cancelText="Cancel"
        >
          Are you sure you want to import smoker rates?
        </Modal>
        {diffIsLoading && <div>Loading...</div>}
        {diffData && (
          <>
            <AnalyzeSummary data={diffData} />
            <table>
              <thead>
                <tr>
                  <th style={{ textAlign: 'left' }}>Diff Status</th>
                  <th style={{ textAlign: 'left' }}>SmokerRateID</th>
                  <th style={{ textAlign: 'left' }}>Year</th>
                  <th style={{ textAlign: 'left' }}>Age</th>
                  <th style={{ textAlign: 'left' }}>State</th>
                  <th style={{ textAlign: 'left' }}>IssuerID</th>
                  <th style={{ textAlign: 'left' }}>IncreaseRate</th>
                  <th style={{ textAlign: 'left' }}>IsActive</th>
                </tr>
              </thead>
              <tbody>
                {filterDiffStatusNotUnchanged(diffData).map((row) => (
                  <tr key={row.smokerRateId}>
                    <td>{row.diffStatus}</td>
                    <td>{row.smokerRateId}</td>
                    <td>{row.year}</td>
                    <td>{row.age}</td>
                    <td>{row.state}</td>
                    <td>{row.issuerId}</td>
                    <td>{row.increaseRate}</td>
                    <td>{row.isActive}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </>
        )}
      </Stack>
    </Page>
  )
}
